import template from './success-modal.html';
import './success-modal.global.css';

export const SuccessModalComponent = {
  template,
  bindings: {
    close: '&',
    dashboardSref: '<',
  },
};
